export function ValidateName(name) {
    const regexName = /.*/;
    return regexName.test(name);
  }